import { render, staticRenderFns } from "./EditLicense.vue?vue&type=template&id=0f1c6e80&scoped=true"
import script from "./EditLicense.vue?vue&type=script&lang=js"
export * from "./EditLicense.vue?vue&type=script&lang=js"
import style0 from "./EditLicense.vue?vue&type=style&index=0&id=0f1c6e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c6e80",
  null
  
)

export default component.exports